<template>
  <div id="clientes">
<div class="col-md-12 flecha-container">  
  <h1 data-aos="fade-up"  data-aos-duration="1500">CLIENTES</h1>
    <img data-aos="fade-right"  data-aos-duration="1500" class="flecha" src="~imgs/icons/Flecha_Blanca.png">
  </div>    
  <div class="clientes-industrasdiv">
    <h2 data-aos="fade-up"  data-aos-duration="1500">INDUSTRIAS</h2>
    <hr data-aos="fade-up"  data-aos-duration="1500">
    <div  style="margin-top:40px;"  data-aos="fade-up"  data-aos-duration="1500" class="paragaphs-conainer">
     <img src="~imgs/icons/Servimos_Papel.png"><p><b>PAPEL</b><br> Empresas que se dedican a la fabricación y manufactura de papel (sanitario, papel para dispensadores, toallas y servilletas de cocina). Entre nuestros clientes tenemos a Papelera San Francisco, S.A. de C.V. </p>
      </div>
      <div data-aos="fade-up"  data-aos-duration="1500" class="paragaphs-conainer">
     <img src="~imgs/icons/Servimos_Zanahoria.png"><p>
                  <b>AGRÍCOLA</b><br>Empresas enfocadas a los productos alimenticios en general como Vilore Foods Inc. y Green Heart Farms Inc.</p>
      </div>
      <div data-aos="fade-up"  data-aos-duration="1500" class="paragaphs-conainer">
     <img src="~imgs/icons/Servimos_Jugo.png"><p><b>EMBOTELLADORA</b><br>Empresas orientadas a embotellar refrescos, jugos, aguas, etc. Dentro de nuestros clientes contamos con Jumex, S.A. de C.V., Arca Continental, Tetrapak, entre otros.</p>
      </div>
      <div data-aos="fade-up"  data-aos-duration="1500" class="paragaphs-conainer">
     <img src="~imgs/icons/Servimos_Herramientas.png"><p><b>EMPAQUETADORA</b><br> Empresas enfocadas a la fabricación de material para empaque y embalaje. Entre nuestros clientes se encuentra Calibaja Manufacturing y Knight Logistics. 
</p>
      </div>
    </div>
     <div class="clientes-empresasdiv">
      <h2 data-aos="fade-up"  data-aos-duration="1500">EMPRESAS</h2>
      <hr data-aos="fade-up"  data-aos-duration="1500">
     </div>
     <div data-aos="fade-up"  data-aos-duration="1500" class="container">
      <div class="row">
  </div>
  <div class='row'>
    <div class='col-md-12'>
      <div class="carousel slide media-carousel" id="media">
        <div class="carousel-inner">
          <div class="item  active">
            <div class="row">
              <div class="col-md-4">
                <a class="thumbnail" href="#"><img alt="" src="~imgs/icons/Empresa_coyote.png"></a>
              </div>          
              <div class="col-md-4">
                <a class="thumbnail" href="#"><img alt="" src="~imgs/icons/Empresa_Greenheart.png"></a>
              </div>
              <div class="col-md-4">
                <a class="thumbnail" href="#"><img alt="" src="~imgs/icons/Empresa_Knight.png"></a>
              </div>        
            </div>
          </div>
          <div class="item">
            <div class="row">
              <div class="col-md-4">
                <a class="thumbnail" href="#"><img alt="" src="~imgs/icons/Empresa_PSF.png"></a>
              </div>          
              <div class="col-md-4">
                <a class="thumbnail" href="#"><img alt="" src="~imgs/icons/Empresa_TQL.png"></a>
              </div>
              <div class="col-md-4">
                <a class="thumbnail" href="#"><img alt="" src="~imgs/icons/Empresa_Vilore.png"></a>
              </div>      
            </div>
          </div>
        </div>
        <a data-slide="prev" href="#media" class="left carousel-control">‹</a>
        <a data-slide="next" href="#media" class="right carousel-control">›</a>
      </div>                          
    </div>
  </div>
</div>
  </div>
  
</template>

<script>
import Arrow from './reusable/ArrowRight.vue'




export default{
  data(){
    return{

    }
  },
  props:['name', 'selector'],
  components: {
    Arrow
  }
  }

</script>

<style lang="scss" scoped>
@import '~varmix';
#clientes{
  height: 100%;
  height: 100%;
  background-color:#000;
  margin-top:100px;
}

.clientes-industrasdiv{
  width:80%;
  min-width:300px;
  text-align:center;
  margin:auto;
}

h2{
  color:#fff;
  margin-top:80px;
}

hr{
  background-color:$dark-red;
  border-color:$dark-red;
  color:$dark-red;
  width:200px;
  height:5px;
}

.paragaphs-conainer{
  text-align:center;
  color:white;
  width:90%;
  margin:auto;
  min-width:300px;
  margin-top:20px;
}
.paragaphs-conainer img{
  width:70px;
  display:inline-block;
  vertical-align:top;
  margin-right:60px;
  margin-top:0px;
  
}

.paragaphs-conainer p{
  display:inline-block;
  width:50%;
  margin:auto;
  text-align:justify;
}
.clientes-empresasdiv{
  text-align:center;
  margin:auto;
}
b{
  font-size:13pt;
}
@media screen and (max-width: 720px){
  .paragaphs-conainer p{
  display:block;
  width:100%;
  
}

.paragaphs-conainer img{
  margin-top:20px;
    margin-bottom:20px;

}

.paragaphs-conainer img{
  margin-right:0px;
}
.media-carousel .carousel-control.left 
{
  display:none;
}
/* Next button  */
.media-carousel .carousel-control.right 
{
 display:none;
}
}

/* carousel */
.media-carousel 
{
  margin-bottom: 0;
  padding: 0 40px 30px 40px;
  margin-top: 30px;
}
/* Previous button  */
.media-carousel .carousel-control.left 
{
  left: -12px;
  height: 40px;
  width : 40px;
  font-size:60px;
}
/* Next button  */
.media-carousel .carousel-control.right 
{
  right: -12px !important;
  height: 40px;
  width : 40px;
  font-size:60px;
}
/* Changes the position of the indicators */
.media-carousel .carousel-indicators 
{
  right: 50%;
  top: auto;
  bottom: 0px;
  margin-right: -19px;
}
/* Changes the colour of the indicators */
.media-carousel .carousel-indicators li 
{
  background: #c0c0c0;
}
.media-carousel .carousel-indicators .active 
{
  background: #333333;
}
.media-carousel img
{
  width: 250px;
  height: 100px
}

.thumbnail{
  background-color:transparent!important;
  border:0px !important;
  width:100%;
}
.thumbnail img{
  width:60%;
}
/* End carousel */

.flecha-container{
  width:100%;
  text-align:left;
  margin-bottom:80px;
}
.flecha-container h1{
float:right;
margin-right:20px;
margin-top:20px;
color:white;
font-size:30pt;
}
.flecha{
margin-left:-30px;
margin-top:20px;
width:80%;
}
</style>



// WEBPACK FOOTER //
// clientes.vue?8f212b84